var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getComponentTypeForBlock(_vm.model),_vm._b({tag:"component",attrs:{"model":_vm.model,"className":_vm.className}},'component',_vm.model,false))}
var staticRenderFns = []

export { render, staticRenderFns }